// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner_banner__3kclb","left":"Banner_left__3qj1L","text":"Banner_text__15WrG","right":"Banner_right__157yC","img":"Banner_img__WYLZS"};